__turbopack_context__.v({
  "container": "InContentAd-module__Y8ZVMq__container",
  "placeholder": "InContentAd-module__Y8ZVMq__placeholder",
});
